import { displayDate, displayDateTime } from '../common/datePresentation';

const FIELD_LABELS = {
  classTypeId: 'Typ zajęć',
  teacherId: 'Nauczyciel',
  dayOfWeek: 'Dzień tygodnia',
  fromDate: 'Data rozpoczęcia',
  tillDate: 'Data zakończenia',
  startTime: 'Godzina rozpoczęcia',
  'lessonDetails.date': 'Data lekcji',
  'lessonDetails.startTime': 'Godzina lekcji',
  'lessonDetails.teacherId': 'Nauczyciel',
  'lessonDetails.classTypeId': 'Typ zajęć',
  'lessonDetails.attendanceStatus': 'Stan obecności',
  'lessonDetails.lessonStatus': 'Stan lekcji',
  'lessonDetails.attendanceCheckedAt': 'Czas sprawdzenia obecności',
  email: 'Adres e-mail',
  mobile: 'Telefon',
  additionalInfo: 'Informacje dodatkowe',
  schoolClassId: 'Grupa',
  studentId: 'Uczeń',
  archived: 'Archiwizacja',
  deleted: 'Usunięcie',
};
const STATUS_LABELS = {
  checked: 'Sprawdzona',
  notChecked: 'Niesprawdzona',
  partiallyCancelled: 'Częściowo odwołana',
  cancelled: 'Odwołana',
  scheduled: 'Zaplanowana',
  cancelledOnTime: 'Odwołana w terminie',
  cancelledLate: 'Odwołana po terminie',
  present: 'Obecny',
  absent: 'Nieobecny',
};

export function changeFieldLabel(field, studentLabels = {}) {
  if (FIELD_LABELS[field]) return FIELD_LABELS[field];
  const studentField = /^students\.([^.]+)\.(isPresent|participationStatus)$/.exec(field);
  if (studentField) return `${studentField[2] === 'isPresent' ? 'Obecność' : 'Udział'} ucznia ${studentLabels[studentField[1]] || studentField[1].slice(0, 8)}`;
  return field;
}

export function changeValueLabel(field, value, teacherOptions = [], classTypeOptions = []) {
  if (value === null || value === undefined) return '—';
  if (field === 'email' && value === '[ukryte]') return 'Wartość ukryta';
  if (field.endsWith('teacherId')) return (teacherOptions.find(option => option[0] === value) || [null, value])[1];
  if (field.endsWith('classTypeId')) return (classTypeOptions.find(option => option[0] === value) || [null, value])[1];
  if (field === 'fromDate' || field === 'tillDate' || field === 'lessonDetails.date') return displayDate(value);
  if (field === 'lessonDetails.attendanceCheckedAt') return displayDateTime(value);
  if (field.endsWith('.isPresent')) return value ? 'Obecny' : 'Nieobecny';
  return STATUS_LABELS[value] || String(value);
}
